module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/media-library-1-26c87b8ef99a3e4b8c6823459db38704.svg";